import React from 'react';
import { Check } from 'lucide-react';

const IndustryChallenge = ({ title, intro, items, outro }) => {
   return (
      <section className="industry-challenge pt-115 pb-90">
         <div className="tw-container tw-mx-auto">
            <div className="tw-flex tw-flex-wrap tw--mx-3">
               <div className="tw-w-full tw-px-3 lg:tw-w-8/12">
                  <div className="section__title section__title-3 mb-25">
                     <h2>{title}</h2>
                  </div>
                  <p className="industry-challenge__intro">{intro}</p>
                  <ul className="industry-challenge__list">
                     {items.map((item, index) => (
                        <li key={index}>
                           <Check size={16} strokeWidth={2.5} aria-hidden="true" />
                           {item}
                        </li>
                     ))}
                  </ul>
                  <p className="industry-challenge__outro">{outro}</p>
               </div>
            </div>
         </div>
      </section>
   );
};

export default IndustryChallenge;
